/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'
import { useNavigate } from 'react-router-dom'
import './ForgotPassword.css'

function ResetPassword() {
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState('')
    const [error, setError] = useState('')
    const [ready, setReady] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        // Supabase sends the recovery token in the URL hash
        // We need to let Supabase process it and establish a session
        const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
            if (event === 'PASSWORD_RECOVERY') {
                setReady(true)
            }
        })

        // Also check if session already exists (user came back to the tab)
        supabase.auth.getSession().then(({ data: { session } }) => {
            if (session) setReady(true)
        })

        return () => subscription.unsubscribe()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError('')
        setMessage('')

        if (password !== confirmPassword) {
            setError('Passwords do not match')
            return
        }

        if (password.length < 6) {
            setError('Password must be at least 6 characters')
            return
        }

        setLoading(true)

        try {
            const { error } = await supabase.auth.updateUser({ password })
            if (error) throw error
            setMessage('Password updated successfully. Redirecting...')
            setTimeout(() => navigate('/'), 2000)
        } catch (err) {
            setError(err.message)
        } finally {
            setLoading(false)
        }
    }

    if (!ready) {
        return (
            <div className="forgot-password-page">
                <div className="forgot-password-card">
                    <p>Verifying your reset link...</p>
                </div>
            </div>
        )
    }

    return (
        <div className="forgot-password-page">
            <div className="forgot-password-card">
                <h1>Set new password</h1>
                <p>Enter your new password below.</p>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>New password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                            className="search-input"
                        />
                    </div>
                    <div className="form-group">
                        <label>Confirm password</label>
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                            required
                            className="search-input"
                        />
                    </div>
                    {error && <p className="error">{error}</p>}
                    {message && <p className="success">{message}</p>}
                    <button type="submit" className="btn-primary full-width" disabled={loading}>
                        {loading ? 'Updating...' : 'Update password'}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default ResetPassword
